// This file is generated by pnpm icons:generate. Do not edit.

import {ListMagnifyingGlass_Stroke2_Corner0_Rounded as CanonicalListMagnifyingGlass_Stroke2_Corner0_Rounded} from './List'

/** @deprecated Import ListMagnifyingGlass_Stroke2_Corner0_Rounded from `#/components/icons/List` instead. */
export const ListMagnifyingGlass_Stroke2_Corner0_Rounded =
  CanonicalListMagnifyingGlass_Stroke2_Corner0_Rounded
